import axios from 'axios'
import {v4} from 'uuid'
import {STORAGE_SESSION_ID_KEY} from "utils/data/global.ts";
import { FRONTEND_TYPES } from "globals/constants.ts";


const ajax = axios.create({
    baseURL: process.env.API_URL + '/api/v1',
    timeout: 15000//15sec,
})

ajax.defaults.headers.common["x-frontend-type"] = FRONTEND_TYPES.WEBSITE;//for mobile app specific
ajax.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add a response interceptor
ajax.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    const statusCode = error?.response?.status ? error.response.status : null

    if (![401, 403].includes(statusCode)) {
        //if not 401 or 403, let's log it
        if (process.env.NODE_ENV === 'production') {
          if (window.Sentry) {
            window.Sentry.captureException(error)
          }
        }
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export const initSessionId = () => {
    let sessionId = window.localStorage.getItem(STORAGE_SESSION_ID_KEY)
    if (!sessionId) {
        sessionId = v4()
        window.localStorage.setItem(STORAGE_SESSION_ID_KEY, sessionId as string)
    }
    ajax.defaults.headers.common["x-session-id"] = sessionId
}

export const resetSessionId = () => {
    window.localStorage.removeItem(STORAGE_SESSION_ID_KEY)
    initSessionId()//will regenerate a new session id
}

initSessionId();

export default ajax
